export class RejectedCompanyError extends Error {}
